module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "NoteListItems"
  }, [_c('div', {
    staticClass: "noteContainer"
  }, [_c('div', {
    staticClass: "topper"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'View Note',
        params: {
          id: _vm.note.id
        }
      }
    }
  }, [_c('a', {
    staticClass: "title",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.subStringTitle(_vm.note.title)))])])], 1)]), _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.parseTimeCreate(_vm.note.meta)))]), _c('div', {
    staticClass: "tag"
  }, [_vm._v(_vm._s(_vm.note.tag))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cf2d84e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoteListItems.vue
// module id = 223
// module chunks = 1